export default {
  RotatingBannerPlacement__ARIA_DIALOG_MODAL_CLOSE: "Press here to close this modal",
  RotatingBannerPlacement__ARIA_DIALOG_MODAL_OPENED: "Modal opened",
  RotatingBannerPlacement__BUTTON_GROUP_ARIA_NEXT: "Next",
  RotatingBannerPlacement__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
};
